import { useTenant } from "@/contexts/TenantContext";

function hexToFilter(hex) {
  // Generate CSS filter to tint logo toward the given hex color
  // Default teal (#6EE7B7) filter
  if (!hex || hex.toLowerCase() === "#6ee7b7") {
    return "brightness(0) saturate(100%) invert(82%) sepia(30%) saturate(500%) hue-rotate(100deg) brightness(101%) contrast(92%)";
  }
  // Parse hex to RGB then compute approximate hue-rotate
  hex = hex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0, l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
      default: break;
    }
  }
  const hDeg = Math.round(h * 360);
  const sat = Math.round(s * 100);
  const lit = Math.round(l * 100);
  // Base: invert + sepia creates a warm orange, then hue-rotate to target
  const hueShift = hDeg - 30; // sepia base is ~30deg
  return `brightness(0) saturate(100%) invert(${Math.min(lit + 30, 95)}%) sepia(${Math.min(sat + 20, 100)}%) saturate(${Math.min(sat * 5 + 200, 800)}%) hue-rotate(${hueShift}deg) brightness(${lit > 50 ? 100 : 90}%) contrast(92%)`;
}

export function Logo() {
  const { tenant } = useTenant();
  const filterStyle = hexToFilter(tenant?.primary_color);

  return (
    <div className="flex items-center gap-3">
      <img
        src="/assets/amp-mineops-logo.png"
        alt="AMP MineOps"
        className="h-11 w-auto"
        style={{ filter: filterStyle }}
      />
      {tenant?.logo_url && (
        <>
          <span className="text-border text-lg font-thin">|</span>
          <img
            src={tenant.logo_url}
            alt={tenant.display_name}
            className="h-9 w-auto max-w-[140px] object-contain"
            data-testid="tenant-logo"
          />
        </>
      )}
    </div>
  );
}

export function LogoFull() {
  const { tenant } = useTenant();
  const filterStyle = hexToFilter(tenant?.primary_color);

  if (tenant) {
    return (
      <div className="flex flex-col items-center">
        {tenant.logo_url ? (
          <img
            src={tenant.logo_url}
            alt={tenant.display_name}
            className="h-24 w-auto max-w-[240px] object-contain mb-3"
            data-testid="tenant-logo-full"
          />
        ) : (
          <p className="font-headline text-3xl font-bold mb-3" data-testid="tenant-name-full">
            {tenant.display_name}
          </p>
        )}
        <p className="text-muted-foreground text-sm">
          {tenant.welcome_message || "Contractor Reporting Portal"}
        </p>
        <div className="flex items-center gap-2 mt-4 opacity-70">
          <img
            src="/assets/amp-mineops-logo.png"
            alt="AMP MineOps"
            className="h-7 w-auto"
            style={{ filter: filterStyle }}
          />
          <span className="text-xs text-muted-foreground">Powered by AMP MineOps</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center">
      <img
        src="/assets/amp-mineops-logo.png"
        alt="AMP MineOps"
        className="h-20 w-auto mb-3"
        style={{ filter: filterStyle }}
      />
      <p className="text-muted-foreground text-sm">Contractor Reporting System</p>
    </div>
  );
}
